api = require('./0_def.coffee')

api.factory 'api/FeatureToggle#factory', [
  'ksc.Record', 'ksc.RestList',
  (Record, RestList) ->
    contract =
      featureKey: { type: 'string' }

    class Feature extends Record
      constructor: (args...) ->
        if typeof args[0] is 'string'
          args[0] =
            featureKey: args[0]
        super args...

    ->
      new RestList
        cache: true
        endpoint:
          url: '/dashboard-calendar-ui/api/FeatureToggle'
        record:
          class: Feature
          contract: contract
          idProperty: 'featureKey'
# url:        '/dashboard-calendar-ui/api/FeatureToggle/<id>'
]


api.service 'api/FeatureToggle', [
  'api/FeatureToggle#factory',
  (featureToggleFactory) ->
    service = featureToggleFactory()

    # entire response can be cached, no partial loads. Load right away.
    service.restLoad()

    service
]
